import { bankServices } from "../../config/axios";
import {
    CASHLIFTINGLIST_SUCCESS,
    CASHLIFTINGLIST_FAILED,
    RESET_CASHLIFTINGLIST,
    LOADING_CASHLIFTINGLIST,
    CASHLIFTINGLIST_NETWORKERROR,
} from '../types/index';

const resetbankCashLiftingList = () => {
    return { type: RESET_CASHLIFTINGLIST };
};

const bankCashLiftingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CASHLIFTINGLIST });
    await bankServices
        .post("cashLiftingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: CASHLIFTINGLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: CASHLIFTINGLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: CASHLIFTINGLIST_FAILED,
        payload: data
    };
}

export { resetbankCashLiftingList, bankCashLiftingList }